import { Component, OnInit, OnDestroy, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { CashOutService, CommonService, ClientWalkInService, SubscribeService, BranchService, ReportsService } from '../../../services/index';
import { CashOutModal } from '../../../model/index';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'add-cash-out-tab',
    templateUrl: './addCashOut.component.html'
})
export class AddCashOutComponent implements OnInit, OnDestroy {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    //@Input() params;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        val['hv_userid'] = val['hv_userid'] ? parseInt(val['hv_userid']) : 0;
        val['acc_userid'] = val['acc_userid'] ? parseInt(val['acc_userid']) : 0;
        this._params = val;
        this.setPageData();
    }
    public mode: string;
    filteredHvuserlist: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    filteredAccUserList: Observable<any[]>;
    branchCtrl: FormControl;
    outTypeCtrl: FormControl;
    hvUserCtrl: FormControl;
    accUserCtrl: FormControl;
    reasonCtrl: FormControl;
    outTypeList: string[] = ['Branch', 'HV Team', 'Accounts'];
    reasonList: string[] = ['HV Expenes', 'Sold Amount'];
    branchList: any[] = [];
    accUserList: any[] = [];
    hvUserList: any[];
    columns = [];
    toggleCol = [];
    filterData = {
        "branch_id": ""
    };
    subscribeAuth;
    cashInHand = '0';
    //@Output() transferChellOutUpdateEvent = new EventEmitter();

    @Input() cashOutData: CashOutModal[] = [];
    @Input() cashOutRow: CashOutModal[] = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('branchAutoComp') branchAutoComp;

    isLoading: boolean = false;
    minDate: any;

    constructor(
        public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private BranchService: BranchService,
        private cashOutService: CashOutService,
        private reportsService: ReportsService,
        private clientWalkInService: ClientWalkInService, public subscribeService: SubscribeService
    ) {
        this.getHVUserList();
        this.getAccUserList();
        
        // FOR ACCOUNT USER FORM CONTROL
        this.accUserCtrl = new FormControl('', [Validators.required, hasValidAccUser.bind(this)]);

        function hasValidAccUser(input: FormControl) {
            const accUserId = input.value;
            const user = _.find(this.accUserList, { 'userid': accUserId });
            if (user) {
                return null;
            }

            return { inValidAccUser: true }
        }

        this.filteredAccUserList = this.accUserCtrl.valueChanges.startWith(null).map(name => name ? this.filterAccUser(name) : this.accUserList.slice());

        //this.getBranchList();
        function hasValidBranch(input: FormControl) {
            let branchID = input.value;
            let femp = _.find(this.branchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidBranch: true };
        }
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
        this.filteredBranch = this.branchCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        //FOR AUTO COMPLETE VALIDATION --- ASSIGN TO LIST
        function hasValidHVUser(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidHVUser: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidHVUser: true };
            }
            return retVal;
        }
        this.hvUserCtrl = new FormControl('', [
            Validators.required,
            hasValidHVUser.bind(this)
        ]);
        this.filteredHvuserlist = this.hvUserCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterHvUser(name) : this.hvUserList ? this.hvUserList.slice() : []);
        

        function hasValidOutType(input: FormControl) {
            if (this.outTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidOutType: true };
        }
        function hasValidReason(input: FormControl) {
            if (this.reasonList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidReason: true };
        }
      
        this.outTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidOutType.bind(this)
        ]);
       
        this.reasonCtrl = new FormControl('', [
            Validators.required,
            hasValidReason.bind(this)
        ]);
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                if (auth['islogin']) {
                    let branchs = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false'});
                    this.branchList = _.filter(branchs, function (obj) { return obj['branch_id'] && obj['store_branch'] == 'Yes'});
                }
            });
        });

    }

    reorderable: boolean = true;

    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'model_id',
        orderDir: 'asc'
    };

    cashOutList = [];

    ngOnInit(): void {

        let that = this;


        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Model', prop: 'name', width: 220, minWidth: 220, maxWidth: 220, toggle: true },
            { name: 'Serial No', prop: 'serial_no', width: 220, minWidth: 220, maxWidth: 220, toggle: true },
            { name: 'MRP', prop: 'mrp', width: 120, minWidth: 120, maxWidth: 120, toggle: true },
            { name: 'Qty', prop: 'qty', width: 120, minWidth: 120, maxWidth: 120, toggle: true, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 90, minWidth: 90, maxWidth: 90, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.cashOutData['date'] = new Date();

            this.getAutoNumber();
        }
        that.subscribeAuth = that.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.filterData['branch_id'] = auth['branch_id'];
                that.getCashinHand();
            }
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        if (!_.isEmpty(this.subscribeAuth)) {
            this.subscribeAuth.unsubscribe();
        }
    }
    
    getAutoNumber() {
        let that = this,
            cashOutDate = moment(this.cashOutData['date']).format('YYYY-MM-DD'),
            params = {
                account_type: 'cashOut',
                date: cashOutDate,
            };
        this.commonService.getAutoNumber(params)
            .then(function (res: any) {
                that.cashOutData['cash_out_no'] = res['auto_no'];
            });
    }
    getHVUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        that.commonService
            .getHVUserList(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.hvUserList = res.data;
                    if (that.mode != 'Add') {
                        that.hvUserCtrl.setValue(that._params['hv_userid']);
                    }
                }
            });
    }
    
    getAccUserList() {
        let that = this;
        this.commonService.getAccUserList({}).then(function (res: any) {
            if (res.success) {
                that.accUserList = res.data;
                if(that.mode != 'Add') {
                    that.accUserCtrl.setValue(that._params['acc_userid']);
                }
            }
        });
    }

    accUserFn(accUserId: string) {
        if (this.accUserList.length && accUserId) {
            let item = _.find(this.accUserList, { 'userid': Number(accUserId) });

            return item['fullname'];
        }
        return '';
    }

    filterAccUser(name: string) {
        name = _.escapeRegExp(name);
        return this.accUserList.filter(el => (new RegExp(name, 'gi').test(el.fullname)));
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(ha => (new RegExp(name, 'gi').test(ha.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    displayOutTypeFn(outType: any) {
        if (this.outTypeList != undefined && this.outTypeList.length > 0 && outType) {
            return this.outTypeList.indexOf(outType) >= 0 ? outType : '';
        }
        return '';

    }

    displayReasonFn(reason: any) {
        if (this.reasonList != undefined && this.reasonList.length > 0 && reason) {
            return this.reasonList.indexOf(reason) >= 0 ? reason : '';
        }
        return '';

    }
    // HV User display
    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }
    assignFn(empid: any) {
        if (this.hvUserList != undefined) {
            if (empid && this.hvUserList.length > 0) {
                if (typeof empid == 'string') {
                    empid = parseInt(empid);
                }
                let fitem = _.find(this.hvUserList, { 'userid': empid });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';

    }

    setPageData(): void {
        let that = this;
        if (that._params != undefined) {
            that.cashOutData = Object.assign({}, that._params);
            that.mode = that._params['mode'];
            that.cashOutData['btnTxt'] = that._params['btnTxt'];
            if (that.mode != 'Add') {
                that.cashOutData['date'] = new Date(that._params['cash_out_date']);
                that.outTypeCtrl.setValue(that._params['out_type']);
                that.branchCtrl.setValue(that._params['branch_id']);
                that.hvUserCtrl.setValue(that._params['hv_userid']);
                that.reasonCtrl.setValue(that._params['reason']);
                that.cashOutData['company_id'] = parseInt(that._params['company_id']);
                if (that._params['mode'] === 'View') {
                    that.branchCtrl.disable();
                    that.hvUserCtrl.disable();
                    that.outTypeCtrl.disable();
                    that.accUserCtrl.disable();
                    that.reasonCtrl.disable();
                }
            }
        }
    }

    onResetCashOut(): void {
        if (this._params['mode'] == 'Add') {
            this.cashOutData = [];
            this.cashOutData['date'] = new Date();
        }
    }

    onBackToList(): void {
        this.subscribeService.subReloadCashOutGrid();
        this.subscribeService.subScribeDeleteActiveTab();
    }

    // To check Cash Out Form is invalid
    hasInvalidCashOutForm() {
        return (this.outTypeCtrl.errors && (this.outTypeCtrl.errors['inValidOutType'] || this.outTypeCtrl.errors['required']))
            || (this.reasonCtrl.errors && (this.reasonCtrl.errors['inValidReason'] || this.reasonCtrl.errors['required']))
            || (this.cashOutData['out_type'] == 'HV Team' ? 
                (!this.cashOutData['hv_userid'] || (this.hvUserCtrl.errors && (this.hvUserCtrl.errors['inValidHVUser'] || !this.hvUserCtrl.errors['required'])))
                    : this.cashOutData['out_type'] == 'Branch' ? (!this.cashOutData['company_id'] || (this.branchCtrl.errors && (this.branchCtrl.errors['inValidBranch'] && !this.branchCtrl.errors['required']))) : (!this.cashOutData['acc_userid'] || (this.accUserCtrl.errors && (this.accUserCtrl.errors['inValidAccUser'] || !this.accUserCtrl.errors['required']))));
    }

    onSaveCashOut() {
        let that = this;
        let cashOutDet = that.cashOutData;
        let cashOutDate = moment(cashOutDet['date']).format('YYYY-MM-DD');
        let handCash = parseFloat(that.cashInHand).toFixed(2);
        if (parseInt(handCash) >= parseInt(cashOutDet['amount'])) {
            if (cashOutDet['btnTxt'] == 'Save') {
                let params = {
                    cash_out_no: cashOutDet['cash_out_no'],
                    cash_out_date: cashOutDate,
                    out_type: cashOutDet['out_type'],
                    companyid: cashOutDet['out_type'] !== 'HV Team' ? cashOutDet['company_id'] : 0,
                    hv_userid: cashOutDet['out_type'] === 'HV Team' ? cashOutDet['hv_userid'] : 0,
                    acc_userid: cashOutDet['out_type'] === 'Accounts' ? cashOutDet['acc_userid'] : 0,
                    amount: cashOutDet['amount'],
                    reason: cashOutDet['reason'],
                    comments: cashOutDet['comments'] ? cashOutDet['comments'] : '',
                    mode: 'Add'
                };
                this.isLoading = true;
                this.cashOutService.addCashOut(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            swal(
                                'SUCCESS',
                                res.message,
                                'success'
                            );

                            that.cashOutList = [];
                            that.cashOutData = [];
                            that.subscribeService.subReloadCashOutGrid();
                            that.subscribeService.subScribeDeleteActiveTab();
                        } else {
                            swal(
                                'ERROR',
                                res.message,
                                'error'
                            );
                        }
                    });
            } else {
                let that = this;
                let params = {
                    cash_out_no: cashOutDet['cash_out_no'],
                    cash_out_date: cashOutDate,
                    out_type: cashOutDet['out_type'],
                    companyid: cashOutDet['out_type'] !== 'HV Team' ? cashOutDet['company_id'] : 0,
                    hv_userid: cashOutDet['out_type'] === 'HV Team' ? cashOutDet['hv_userid'] : 0,
                    acc_userid: cashOutDet['out_type'] === 'Accounts' ? cashOutDet['acc_userid'] : 0,
                    amount: cashOutDet['amount'],
                    reason: cashOutDet['reason'],
                    comments: cashOutDet['comments'] ? cashOutDet['comments'] : '',
                    cash_out_id: cashOutDet['cash_out_id'],
                    mode: 'Update'
                };
                this.isLoading = true;
                this.cashOutService.UpdateCashOut(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            swal(
                                'SUCCESS',
                                res.message,
                                'success'
                            );
                            that.subscribeService.subReloadCashOutGrid();
                            that.subscribeService.subScribeDeleteActiveTab();
                        } else {
                            swal(
                                'ERROR',
                                res.message,
                                'error'
                            );
                        }
                    });
            }
        } else {
            swal(
                'ERROR',
                'Cash In Hand is not sufficient!',
                'error'
            );
        }
    }

    calModel(){
        this.getCashinHand();
    }

    getCashinHand() {
        let that = this;
        that.isLoading = true;
        let reqData = {
            start: 0,
            limit: 5,
            orderColumn: 'bill_id',
            orderDir: 'asc',
            page_type: 'daybook',
            branch_id: that.filterData['branch_id'],
            view: 'Summary View',
            view_type:'',
            from_date: moment(that.cashOutData['date']).format('YYYY-MM-DD') ? moment(that.cashOutData['date']).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),//moment(new Date()).format('YYYY-MM-DD'),
            to_date: moment(that.cashOutData['date']).format('YYYY-MM-DD') ? moment(that.cashOutData['date']).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD')
        }
        that.reportsService
            .getReports(reqData)
            .then(function (res: any) {
                that.isLoading = false;
                if(res && res.data && res.data.length) {
                    let drAmount = res.data1[res.data1.length - 1]['dramount'];
                    that.cashInHand = drAmount ? drAmount : '0';
                } else {
                    that.cashInHand = '0';
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashOut/addCashOut.component.ts